//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TransientObject.js";
let d=[[[0,"DebugMode",0,0]],[[[],"Dispose",{},0,0],[["primaryParam"],"SetPrimaryParam",{},1,0],[["paramObject"],"AddParam",{},1,0],[[],"DoMassEdit",{},0,0],[["numParamBuilders"],"GetParamBuilders",{R_:{paramBuilders:"CAM.ParamBuilder[]"}},0,0],[[],"GetPrimaryParamBuilder",{R_:{primaryParamBuilder:"CAM.ParamBuilder"}},0,0],[["count"],"GetEligibleProperties",{R_:{eligibleProperties:""}},0,0],[["propertyName","propertyValues"],"AddPropertyValues",{},2,0],[["traceName","name","text"],"DebugTrace",{},3,0],[[],"GetEligiblePropertyObject",{R_:{eligibleProperties:"CAM.ObjectProperty"}},0,0],[[],"GetPropertiesBeforeEdit",{R_:{root:"CAM.ObjectProperty"}},0,0],[[],"GetPropertiesAfterEdit",{R_:{root:"CAM.ObjectProperty"}},0,0]],[]];
SPLM.CAM.MassEditBuilder = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MassEditBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;